const PREFIX = 'meal_grb_';

const LocalStorageHelper = {
	/**
	 * Get the bearer token from local storage
	 * @returns {String} returns empty string if the item is not present
	 */
	getUserEmail: () => {
		try {
			return localStorage.getItem(`${PREFIX}user_email`);
		} catch (e) {
			return '';
		}
	},

	/**
	 * Set the bearer token to local storage
	 * @param {String} token
	 * @returns {void}
	 */
	setUserEmail: (token) => {
		try {
			localStorage.setItem(`${PREFIX}user_email`, token);
		} catch (error) {
			console.log(error);
		}
	},

	/**
	 * Remove bearer token item from local storage
	 * @returns {void}
	 */
	removeUserEmail: () => {
		localStorage.removeItem(`${PREFIX}user_email`);
	}
};

export default LocalStorageHelper;
